import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
const SelectAgreementOption = ({
  agreementOption,
  onChange,
  validationErrors,
  label = true,
  isSelected,
  isDisabled = false,
}) => {
  return (
    <FormControl fullWidth disabled={validationErrors?.organization || isDisabled}>
      {label ? (
        <InputLabel id="agreement-option-label" error={isSelected ? validationErrors.agreementOption : false}>
          Agreement Option
        </InputLabel>
      ) : null}

      <Select
        labelId="agreement-option-label"
        label={label ? 'Agreement Option' : ''}
        value={agreementOption}
        onChange={onChange}
        required
        error={isSelected ? validationErrors.agreementOption : false}
        // sx={{
        //   '&.Mui-disabled': {
        //     backgroundColor: 'background.defaultdim', // Light red background when disabled
        //   },
        // }}
      >
        <MenuItem value="New/Add-on Business">New/Add-on Business</MenuItem>
        <MenuItem value="Replace Existing Business">Replace Existing Business</MenuItem>
      </Select>
      {/* <FormHelperText>{validationErrors.agreementOption && 'Agreement Option is required'}</FormHelperText> */}
    </FormControl>
  )
}

export default SelectAgreementOption
